export default __webpack_public_path__ + "static/media/designing.448add39.svg";